import { colors } from "../../../utils/styled/_variables.styled"
import Icon from "../../Icon/Icon";

export function ReadingTimeLabel({ readingTime }) {
	if (!readingTime) return null
	return <span className="rel-content__card__readingtime">
		<Icon color={colors.white} icon="eye-filled" />{readingTime} min
	</span>
}
